'use strict';

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

require('../sections/menu');

require('../sections/tables');

require('../templates/cart');

require('../templates/home');

require('../templates/index');

require('../sections/barba');

require('../sections/product');

require('../sections/cookie');

require('../../styles/custom.scss');

require('../../styles/custom.scss.liquid');

var _themeA11y = require('@shopify/theme-a11y');

// Common a11y fixes
(0, _themeA11y.focusHash)();
(0, _themeA11y.bindInPageLinks)();

function cookiesEnabled() {
  return navigator.cookieEnabled;
}

// Apply a specific class to the html element for browser support of cookies.
if (cookiesEnabled()) {
  document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
}

var links = document.links;
for (var i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
  }
}